import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

type StyledProps = {
  $active: boolean;
};

export const InfoContainer = styled.div`
  margin-left: 32px;
  display: flex;
  margin-bottom: 32px;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  margin-right: 32px;
`;

export const Content = styled.div``;

export const Title = styled.label<StyledProps>`
  padding: 0px;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: -0.1px;
  color: ${({ $active }) => ($active ? ColorPalette.HEX.PineTree : ColorPalette.HEX.Manatee)};
`;

export const Value = styled.label<StyledProps>`
  padding: 0px;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: -0.1px;
  color: ${({ $active }) => ($active ? ColorPalette.HEX.DimGray : ColorPalette.HEX.Manatee)};
  max-width: calc(100vw - 100px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
